export default __webpack_public_path__ + "static/media/vodafonecash_fawry.c2dc7f98.png";